import React, { useState } from "react";
import { Theme, createStyles, makeStyles, Grid } from "@material-ui/core";
import LabelIcon from "@material-ui/icons/Label";
import DeleteIcon from "@material-ui/icons/Delete";
import { Label } from "./labels";
import { ILabel } from "../../core/redux/dataMap/label";
import { ISnippet } from "../../core/redux/dataMap/snippet";

interface IOverlayProps {
  snippet: ISnippet;
  articleId: number;
  isFocus: boolean;
  onClose(): void;
  onDelete(): void;
  setLabel(snippetId: number, label: ILabel): void;
  removeLabel(snippetId: number, label: ILabel): void;
}

const Overlay: React.FC<IOverlayProps> = ({
  snippet,
  articleId,
  children,
  isFocus,
  onClose,
  onDelete,
  setLabel,
  removeLabel,
}) => {
  const classes = useStyles();
  const [isLabelsOpen, setLabelsOpen] = useState(false);
  const handleClose = () => {
    setLabelsOpen(false);
    onClose();
  };
  return (
    <>
      <Grid
        container
        direction="column"
        className={isFocus ? classes.chield : ""}
        spacing={1}
      >
        <Grid item>
          <div>{children}</div>
        </Grid>
        <Grid item>
          {isFocus && (
            <div className={classes.options}>
              <Grid container spacing={2} justify="flex-end">
                <Grid item md={6} xs={6}>
                  {isLabelsOpen && (
                    <Label
                      onClose={() => setLabelsOpen(false)}
                      setLabel={setLabel}
                      removeLabel={removeLabel}
                      articleId={articleId}
                      snippetLabels={snippet.labels}
                    />
                  )}
                </Grid>
                <Grid item md={3} xs={3}>
                  <div
                    className={classes.option}
                    onClick={() => setLabelsOpen(true)}
                  >
                    <LabelIcon className={classes.icon} />
                    <span>Taggen</span>
                  </div>
                </Grid>
                <Grid item md={3} xs={3}>
                  <div className={classes.option} onClick={onDelete}>
                    <DeleteIcon className={classes.icon} />
                    <span>Delete</span>
                  </div>
                </Grid>
              </Grid>
            </div>
          )}
        </Grid>
      </Grid>
      <div className={isFocus ? classes.root : ""} onClick={handleClose}></div>
    </>
  );
};

export default Overlay;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      position: "fixed",
      background: "rgba(0,0,0,.6)",
      width: "100%",
      height: "100vh",
      zIndex: 1000,
      top: 0,
      left: 0,
      overflow: "auto",
    },
    chield: {
      position: "relative",
      //   top: "212px",
      //   left: "576px",
      paddingRight: "15px",
      zIndex: 2000,
    },
    options: {
      //   display: "flex",
      //   alignItems: "center",
      //   justifyContent: "flex-end",
    },
    option: {
      background: "rgba(0,0,0,.6)",
      color: "#fff",
      padding: "2px 10px",
      borderRadius: "5px",
      marginBottom: "5px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontFamily: "Roboto",
      fontSize: "13px",
    },
    icon: {
      fontSize: "13px",
      marginRight: "5px",
    },
  })
);
